module.exports = __webpack_public_path__ + "v294910/img/fold.664fa225.png";